"use client";
import "../../../chunk-MMUBH76A.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { CpslButton, CpslText } from "@getpara/react-components";
import { Heading, StepContainer, InnerStepContainer, HeroIcon } from "../common.js";
import { useThemeStore } from "../../stores/index.js";
const TwoFactorDoneStep = ({ onClose }) => {
  const hideWallets = useThemeStore((state) => state.hideWallets);
  return /* @__PURE__ */ jsxs(StepContainer, { children: [
    /* @__PURE__ */ jsx(HeroIcon, { icon: "checkCircleFilled" }),
    /* @__PURE__ */ jsxs(InnerStepContainer, { children: [
      /* @__PURE__ */ jsx(Heading, { variant: "headingXS", weight: "semiBold", children: "Success" }),
      /* @__PURE__ */ jsxs(CpslText, { variant: "bodyS", color: "secondary", weight: "medium", children: [
        "Your ",
        hideWallets ? "account" : "wallet",
        " is now protected by 2FA"
      ] })
    ] }),
    /* @__PURE__ */ jsx(CpslButton, { fullWidth: true, onClick: onClose, children: "Done" })
  ] });
};
export {
  TwoFactorDoneStep
};
